import {AssetType} from '@hconnect/common/types'

import {useGrindingCircuits} from '../../hooks/grindingCircuits'
import {ItemDetailsLayout} from '../../plant-setup-item-layout'

import {GrindingCircuitsCreate} from './GrindingCircuitsCreate'
import {GrindingCircuitsList} from './GrindingCircuitsList'

import {useAssetsQuery} from '@settings/modules/common/hooks'

export const GrindingCircuits = () => {
  const {data, isLoading, isFetching} = useGrindingCircuits()
  const {
    data: assets,
    isLoading: isLoadingAssets,
    isFetching: isFetchingAssets
  } = useAssetsQuery({types: [AssetType.CementMill]})

  return (
    <ItemDetailsLayout>
      <GrindingCircuitsList
        grindingCircuits={data}
        assets={assets}
        isFetching={isFetching || isFetchingAssets}
        isLoading={isLoading || isLoadingAssets}
      />
      <GrindingCircuitsCreate assets={assets} />
    </ItemDetailsLayout>
  )
}
